import { render, staticRenderFns } from "./ShakeButton.vue?vue&type=template&id=46168498&scoped=true"
import script from "./ShakeButton.vue?vue&type=script&lang=js"
export * from "./ShakeButton.vue?vue&type=script&lang=js"
import style0 from "./ShakeButton.vue?vue&type=style&index=0&id=46168498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46168498",
  null
  
)

export default component.exports